import { BehaviorSubject, Observable } from 'rxjs';
import { IAuthorizationDto, IPublicUserAuthorizationDto } from 'redux/session/session';

const STORAGE_KEY = 'currentUser';

const readFromStorage = (): IPublicUserAuthorizationDto | null => {
  const stored = sessionStorage.getItem(STORAGE_KEY);
  return stored ? JSON.parse(stored) : null;
};

const writeToStorage = (currentUser: IPublicUserAuthorizationDto | null) => {
  if (currentUser) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(currentUser));
  } else {
    sessionStorage.removeItem(STORAGE_KEY);
  }
};

const currentUserSubject = new BehaviorSubject<IPublicUserAuthorizationDto | null>(readFromStorage());

const currentUser$: Observable<IPublicUserAuthorizationDto | null> = currentUserSubject.asObservable();

const getCurrentUser = (): IPublicUserAuthorizationDto | null => currentUserSubject.value;

const storeCurrentUser = (dto: IPublicUserAuthorizationDto): void => {
  const currentUser = { ...dto };
  delete currentUser.token;
  delete currentUser.refreshToken;

  writeToStorage(currentUser);
  currentUserSubject.next(currentUser);
};

const renewCurrentUser = (dto: IAuthorizationDto): void => {
  const authorizationDto = { ...dto };
  delete authorizationDto.token;
  delete authorizationDto.refreshToken;

  const currentUser = { ...currentUserSubject.value, ...authorizationDto } as IPublicUserAuthorizationDto;

  writeToStorage(currentUser);
  currentUserSubject.next(currentUser);
};

const clearCurrentUser = (): void => {
  writeToStorage(null);
  currentUserSubject.next(null);
};

export {
  currentUser$, getCurrentUser, storeCurrentUser, renewCurrentUser, clearCurrentUser
};
